import { render } from "./OwnerCaseSelectionView.vue?vue&type=template&id=6498fb1c&scoped=true"
import script from "./OwnerCaseSelectionView.vue?vue&type=script&lang=js"
export * from "./OwnerCaseSelectionView.vue?vue&type=script&lang=js"

import "./OwnerCaseSelectionView.vue?vue&type=style&index=0&id=6498fb1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6498fb1c"]])

export default __exports__